import { HttpHeaders, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { throwError, Observable, catchError } from 'rxjs';
import { BasicResponse } from '../model/basic-response';
import { ConfigService } from './config.service';
import { UserAccessControlService } from './user-access-control.service';
import { rtcPocketInterface, rtcPocketResponseInterface } from '../model/rtc-pocket';

@Injectable({
  providedIn: 'root'
})
export class RtcService {

  private URL;
  headers: HttpHeaders;

  constructor( @Inject(ConfigService) private config: any, private httpClient: HttpClient) {
    this.URL = config.REST_SERVER_url.find((restUrl: any) => restUrl.api === 'MITENS').host + config.REST_SERVER_url.find((restUrl: any) => restUrl.api === 'MITENS').url;
    this.headers = new HttpHeaders().set('DoNotIntercept', 'true');
  }

  private static handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.error(
          `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    return throwError(error);
  }


  createPocket(rtcPocketObj: rtcPocketInterface): Observable<rtcPocketResponseInterface> {
    const headers = this.headers;
    return this.httpClient.post<rtcPocketResponseInterface>(`${this.URL}/transaction/createpocket`,
    rtcPocketObj, { headers })
  }
}
